import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <div className='container-footer'>
        <div className='layout'>
            <div className='footer'>
                <div>гр. Хасково</div>
                <div>Национална Политическа Партия - БЪЛГАРЕ</div>
                <div className='signature'>2026 © Mихал Aндонов</div>
            </div>
        </div>
    </div>
  )
}

export default Footer